import 'jssocials';

import 'theme/moydom/less/blocks/social-share.less';

class WidgetShare {
    init() {
        // Устарело, необходимо убрать
        $('.js-voting-socials-right').jsSocials({
            showCount: false,
            shares: [
                'vkontakte',
                'telegram',
                // 'facebook',
                // 'twitter'
            ],
        });
        $('.js-voting-socials').jsSocials({
            showCount: false,
            shares: [
                'vkontakte',
                'telegram',
                // 'facebook',
                // 'twitter',
                'email',
                'whatsapp',
            ],
        });
        // Устарело, необходимо убрать

        $('.js-socialsshare-right').jsSocials({
            showCount: false,
            shares: [
                'vkontakte',
                'telegram',
                // 'facebook',
                // 'twitter'
            ],
        });
        $('.js-socialsshare-bottom').jsSocials({
            showCount: false,
            shares: [
                'vkontakte',
                'telegram',
                // 'facebook',
                // 'twitter',
                'email',
                'whatsapp',
            ],
        });
    }
}

$(() => {
    new WidgetShare().init();
});
